<template>
  <div id="examDetailPage"
       class="container-fluid has-action-bar has-footer">
    <div v-if="showAlert" class="mx-2 mt-5 knowledge-base-body">
      <div class="col-12">
        <v-alert
            border="bottom"
            class="text-center"
            dark
            type="warning">
          مهلت شما برای پاسخ به سوالات به اتمام رسیده در صورت ثبت نکردن پاسخ ها،میتوانید تا پایان اتمام ساعت پایانی
          آزمون پاسخنامه خود را ثبت کنید.
        </v-alert>
      </div>
    </div>
    <div v-if="examDetail !== null">
      <ActionBar :title=" 'آزمون ' + examDetail.Name "></ActionBar>
      <div class="container">
        <div class="row">
          <div class="col-9 col-md-5 align-self-center">
            <div><span class="font-weight-bold"><i class="fas fa-calendar-alt primary-text pl-2"></i> تاریخ برگزاری آزمون:</span>
              <div v-if="examDetail.ExamEndDate !== examDetail.ExamStartDate">
                از {{ $convertDate(examDetail.ExamStartDate) }} تا {{ $convertDate(examDetail.ExamEndDate) }}
              </div>
              <div v-else>
                {{ $convertDate(examDetail.ExamStartDate) }}
              </div>
            </div>
          </div>
          <div v-if="showPercentage || !currentExam" class="col-3">
            <div class="pt-3 text-right font-weight-bold">نتیجه آزمون</div>
            <v-progress-circular
                :rotate="90"
                :size="80"
                :value="correctAnswerPercentage"
                :width="15"
                color="forth">
              <!--              %{{ $roundNum(correctAnswerPercentage) }}-->
              %{{ Number(correctAnswerPercentage.toFixed(1)) }}
            </v-progress-circular>
          </div>
          <div class="col-12 col-md-5">
            <div><span class="font-weight-bold"><i class="fas fa-alarm-clock primary-text pl-2"></i> ساعت برگزاری آزمون:</span>
              از {{ (examDetail.TimeStart).slice(0, 5) }} تا {{ (examDetail.TimeEnd).slice(0, 5) }}
            </div>
          </div>
          <div v-if="currentExam" class="col-12 col-md-5">
            <div><span class="font-weight-bold"><i class="fas fa-user-clock primary-text pl-2"></i> زمان پاسخ به آزمون:</span>
              {{ examDetail.Minute }} دقیقه
            </div>
          </div>
          <div v-if="currentExam" class="col-12 col-md-5">
            <div><span class="font-weight-bold"> <i class="fas fa-stopwatch primary-text pl-2"></i>  پایان آزمون برای شما:  </span>
              {{ userExamEndTime }}
            </div>
          </div>
          <div v-if="uniqueLessons.length > 0" class="col-12 text-center">
            <div v-if="uniqueLessons.length === 1">
              <div class="font-weight-bold"><i class="fas fa-book primary-text pl-2"></i>درس:</div>
              {{ lessonWithNames[0].Name }}
            </div>
            <div v-else>
              <div v-if="showPercentage || !currentExam" class="text-center">
                <div class="font-weight-bold"><i class="fas fa-book primary-text pl-2"></i>دروس:</div>
                <div class="border-right pr-2 mr-2 my-5 d-inline-block text-center" v-for="(item, index) in totalResult"
                     :key="index">
                  <span class="d-block">{{ item.name }}</span>
                  <v-progress-circular
                      :rotate="90"
                      :size="80"
                      :value="item.percent"
                      :width="15"
                      color="forth">
                    <!--                    %{{ $roundNum(item.percent) }}-->
                    %{{ Number(item.percent.toFixed(1)) }}
                  </v-progress-circular>
                </div>
              </div>
              <div v-else>
                <div class="font-weight-bold"><i class="fas fa-book primary-text pl-2"></i>دروس:</div>
                <span class="border-right pr-2 mr-2" v-for="(item, index) in lessonWithNames" :key="index">
                {{ item.Name }}
            </span>
              </div>

            </div>
          </div>
          <div v-if="ranks.length > 0" class="col-12 text-center">
            <div class="font-weight-bold"><i class="fas fa-book primary-text pl-2"></i>رتبه:</div>
            <div class="border-right pr-2 mr-2 my-5 d-inline-block text-center" v-for="(item, index) in ranks"
                 :key="index">
              <span class="d-block">{{ item.type }}</span>
              <span class="d-block">{{ item.value }}</span>
            </div>

          </div>
          <div class="col-12 ">
            <div v-if=" examDetail.Description !== null">
              <div class="font-weight-bold"><i class="fas fa-info-circle primary-text pl-2"></i>درباره آزمون:</div>
              {{ examDetail.Description }}
            </div>
          </div>
          <div v-if="isPdfLoaded" class="col-12 p-0">
            <vue-pdf-app :config="config"
                         :pdf="testPdf"
                         style="height: 100vh"></vue-pdf-app>
          </div>

        </div>
      </div>
      <v-fab-transition>
        <v-btn
            id="memberShipFabBtn"
            color="forth"
            dark
            fab
            fixed
            left
            x-large
            @click="drawer= true">
          <div class="text-center">
            پاسخنامه
          </div>
        </v-btn>
      </v-fab-transition>
      <v-navigation-drawer
          v-model="drawer"
          color="third"
          fixed
          right
          style="height:100vh !important;"
          temporary>
        <div v-if="isLoaded" class="container">
          <div class="row">
            <div class="third-background col-12 white--text text-center">
              پاسخنامه
            </div>
            <div v-for="index in examDetail.NumberQuestion" :key="index" class="col-12 fourth-border-bottom">
              <div class="font-weight-bold text-center"><i class="fal fa-pencil-alt primary-text font16px"></i> پاسخ
                سوال
                {{ index }}
              </div>
              <div v-if="examDetail.TypeAnswerExam === 2" class="options-field ">
                <v-radio-group
                    v-model="fourChoiceAnswer[index]"
                    :readonly="!canAnswer"
                    column
                    dense
                    hide-details
                    @change="saveAnswers">
                  <v-radio
                      label="گزینه 1"
                      value="1"></v-radio>
                  <v-radio
                      label="گزینه 2"
                      value="2"></v-radio>
                  <v-radio
                      label="گزینه 3"
                      value="3"></v-radio>
                  <v-radio
                      label="گزینه 4"
                      value="4"></v-radio>
                </v-radio-group>
                <div v-if="!currentExam || showCorrectAnswers " class="third-text font-weight-bold">
                  <span class="mt-1">پاسخ صحیح:</span>
                  گزینه {{ correctAnswer[index - 1] }}
                </div>
              </div>
              <div v-else class="options-field">
                <v-radio-group
                    v-model="fourChoiceAnswer[index]"
                    :readonly="!canAnswer"
                    column
                    details
                    @change="saveAnswers">
                  <v-radio
                      label="گزینه 1"
                      value="1"></v-radio>
                  <v-radio
                      label="گزینه 2"
                      value="2"></v-radio>
                </v-radio-group>
                <div v-if="!currentExam || showCorrectAnswers " class=" third-text">
                  <span class="mt-1">پاسخ صحیح:</span>
                  گزینه
                  {{ correctAnswer[index - 1] }}
                </div>
              </div>
            </div>
            <div class="col-12">
              <div v-if="currentExam">
                <v-btn :disabled="disabledRegisterBtn" color="primary" rounded @click="checkCanRegister">ثبت
                  پاسخنامه
                </v-btn>
              </div>
            </div>
          </div>

        </div>
      </v-navigation-drawer>


    </div>
    <FooterMenu/>
    <v-dialog
        v-model="showResultDialog"
        hide-overlay
        persistent
        width="500">
      <v-card class="text-center pt-5">
        <v-card-text class="pb-0">
          <div class="mb-0 black--text">{{ dialogResult }}</div>
          <div v-if="showPercentage">
            <div v-if="typeFeedbackExam === 1 || typeFeedbackExam ===2">
              نمره شما : {{ $roundNum(correctAnswerPercentage) }} می باشد.
            </div>
          </div>

        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="pt-1 pb-3">
          <v-btn block class="primary" rounded @click="showResultDialog = !showResultDialog">
            بستن
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
        v-model="showErrorDialog"
        hide-overlay
        persistent
        width="500">
      <v-card class="text-center pt-5">
        <v-card-text class="pb-0">
          <div class="mb-0 black--text">{{ dialogResult }}</div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="pt-1 pb-3">
          <v-btn block class="primary" rounded @click="goBackPage">
            بستن
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
        v-model="showLoaderDialog"
        hide-overlay
        persistent
        width="500">
      <v-card class="text-center py-5">
        <v-progress-circular
            color="primary"
            indeterminate
        ></v-progress-circular>
      </v-card>
    </v-dialog>
    <v-dialog
        v-model="showConfirmSetAnswer"
        persistent
        width="500">
      <v-card class="text-center pt-5">
        <v-card-text class="pb-0">
          <div class="mb-0 black--text">آیا از اتمام آزمون و ثبت پاسخ مطمئنید؟</div>
          <div class="mb-0 black--text font12px">بعد از ثبت پاسخ امکان تغییر آن وجود ندارد.</div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="pt-1 pb-3 justify-space-around">
          <v-btn class="px-8" color="forth" rounded @click="showConfirmSetAnswer = !showConfirmSetAnswer">
            <span class="white--text">بستن</span>
          </v-btn>
          <v-btn class="px-8" color="primary" rounded @click="setAnswer">
            ثبت پاسخ
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
let _this = null
let checkInterval = null
import VuePdfApp from "vue-pdf-app";
import "vue-pdf-app/dist/icons/main.css";
import ActionBar from "../components/ActionBar";
import FooterMenu from "../components/FooterMenu";

let questionLessons = [];

export default {
  name: "ExamDetail",
  metaInfo: {
    title: 'مسیربرتر-آزمون'
  },
  components: {FooterMenu, ActionBar, VuePdfApp},
  data: () => ({
    showErrorDialog: false,
    testPdf: null,
    theme: '#8057EF',
    fourChoiceAnswer: {},
    examDetail: null,
    isLoaded: false,
    isPdfLoaded: false,
    drawer: false,
    examDetailID: null,
    showResultDialog: false,
    dialogResult: null,
    showLoaderDialog: false,
    showAlert: false,
    showConfirmSetAnswer: false,
    canAnswer: null,
    examID: null,
    pdfUrl: null,
    typeFeedbackExam: null,
    correctAnswer: null,
    showCorrectAnswers: false,
    correctAnswerPercentage: 0,
    showPercentage: false,
    disabledRegisterBtn: false,
    userExamEndTime: null,
    currentExam: true,
    blobFile: null,
    config: {
      secondaryToolbar: false,
      toolbar: {
        toolbarViewerLeft: {findbar: false},
        toolbarViewerRight: false,
        toolbarViewerMiddle: {
          scaleSelectContainer: false
        }
      }

    },
    lessonsList: [],
    lessonWithNames: [],
    uniqueLessons: [],
    totalResult: [],
    ranks: []
  }),
  mounted() {
    _this = this;

    // _this.pdfUrl = 'https://admin.masirebartarapp.com/img/SpecializedFileStudentProfileModel/6b2e2b5f6fa54ceeb79daeea08d40592.pdf'
    this.showLoaderDialog = true
    this.examID = this.$route.query.ExamID
    this.setPageState();
    this.getExamDetail();
    this.getExamAnswers();

    if (this.currentExam) {

      checkInterval = setInterval(function () {
        let currentDate = new Date();
        let currentTime = currentDate.getHours() + ':' + currentDate.getMinutes()

        if (this.examDetail !== undefined) {
          let examEnd = this.examDetail.ExamEndDate.slice(0, 11) + this.examDetail.TimeEnd;

          if (examEnd < currentTime) {
            _this.canAnswer = true

            if (_this.canAnswer && _this.currentExam && _this.showPercentage) {
              _this.showAlert = false
            } else {
              _this.showAlert = true
            }
          }

        }
      }, 30000)
    }


  },
  destroyed() {
    clearInterval(checkInterval)
  },

  methods: {
    checkCanRegister() {
      let current = new Date()
      let examEnd = this.examDetail.ExamEndDate.slice(0, 11) + this.examDetail.TimeEnd;

      if (current <= new Date(examEnd)) {
        this.showConfirmSetAnswer = true
      } else {
        this.dialogResult = 'زمان آزمون به پایان رسیده است'
        this.showErrorDialog = true
      }
    },
    setPageState() {
  /*    if (this.$route.query.CanAnswer === 'true') {
        this.canAnswer = false
      } else if (this.$route.query.CanAnswer === 'false') {
        this.canAnswer = true
      }
*/
      this.canAnswer = (this.$route.query.CanAnswer === 'true');

      /*if (this.$route.query.currentExam === 'true') {
        this.currentExam = true
      } else if (this.$route.query.currentExam === 'false') {
        this.currentExam = false
      }*/

      this.currentExam = (this.$route.query.currentExam === 'true');

      this.userExamEndTime = (this.$getExamData())[this.examID]
      let currentDate2 = new Date();
      let currentTime2 = ((new Date(currentDate2.getTime())).toLocaleTimeString('en-GB')).slice(0, 5)
      if (_this.userExamEndTime < currentTime2) {
        _this.canAnswer = true
        if (_this.canAnswer && _this.currentExam) {
          _this.showAlert = false
        } else {
          _this.showAlert = false
        }
      }

    },
    setSaveAnswers() {
      let answers = this.$getExamAnswers()
      if (answers[this.examID] !== undefined) {
        this.fourChoiceAnswer = answers[this.examID]
      } else {
        let numQuestion = this.examDetail.NumberQuestion
        for (let i = 1; i <= numQuestion; i++) {
          this.fourChoiceAnswer[i] = '0'
        }
      }
    },
    saveAnswers() {
      this.$setExamAnswers(this.examID, this.fourChoiceAnswer)
    },
    getExamDetail() {
      let myHeaders = new Headers();
      myHeaders.append("Authorization", _this.$getUserData().token);

      let requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "ExamManagement/SpcialExam?ExamID=" + this.$route.query.ExamID, requestOptions)
          .then(response => response.text())
          .then(result => {
            let json = JSON.parse(result);

            _this.examDetail = json
            _this.testPdf = _this.$replaceHttps(json.FileUrl)
            _this.setSaveAnswers()
            _this.typeFeedbackExam = json.TypeFeedbackExam
            _this.showLoaderDialog = false
            _this.isLoaded = true
            _this.isPdfLoaded = true

          })
          .catch(error => console.log('error', error));
    },
    async getExamAnswers() {
      let myHeaders = new Headers();
      myHeaders.append("Authorization", _this.$getUserData().token);

      let requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };
      fetch(this.$baseUrl + "ExamManagement/ListExamDetial?ExamID=" + this.$route.query.ExamID, requestOptions)
          .then(response => response.text())
          .then(async result => {
            let text = JSON.parse(result)
            if (text.length === 0) {
              _this.showErrorDialog = true
              _this.dialogResult = 'در فرایند آزمون مشکلی پیش آمده با پشتیبانی تماس بگیرید'
            } else {

              let json = (JSON.parse(result))[0]
              questionLessons = json.QuestionLeason;

              _this.examDetailID = json.ExamDetialID
              if (!_this.currentExam) {
                _this.correctAnswer = json.CorrectAnswer

              }
              await this.getLessons();

              _this.getCorrectAnswers(json.ExamDetialID)
            }
          })
          .catch(error => console.log('error', error));
    },
    getCorrectAnswers(id) {
      let myHeaders = new Headers();
      myHeaders.append("Authorization", _this.$getUserData().token);

      let requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "ExamManagement/HistoryAnswer?ExamDetialID=" + id, requestOptions)
          .then(response => response.text())
          .then(result => {
            let json = JSON.parse(result);

            if (json.length > 0) {
              _this.correctAnswer = json[0].CorrectAnswer;
              let correct = json[0].CorrectAnswer;
              let yourAnswer = json[0].YourAnswer;
              let correctNumber = 0;
              let j = 1;

              let totalResult = {};


              for (let i in correct) {
                let tempId = json[0].QuestionLeason[i];
                let tempRecord = totalResult[tempId];
                if (tempRecord === undefined || tempRecord === null) {
                  tempRecord = {};
                  let tempLesson = this.lessonWithNames.filter(x => x.LessonsFunID === tempId)[0];
                  tempRecord.name = tempLesson.Name;
                  tempRecord.total = 1;
                  const currentPoint = correct[i].toString() === yourAnswer[j].toString() ?
                      1 : 0;
                  tempRecord.correct = currentPoint;
                  tempRecord.percent = 100;
                  totalResult[tempId] = tempRecord;
                } else {
                  const currentPoint = correct[i].toString() === yourAnswer[j].toString() ?
                      1 : 0;
                  tempRecord.correct += currentPoint;
                  tempRecord.total++;
                  tempRecord.percent = (tempRecord.correct / tempRecord.total) * 100;

                }
                if (correct[i].toString() === yourAnswer[j].toString()) {
                  correctNumber++
                }
                j++
              }
              let numQuestion = _this.examDetail.NumberQuestion
              _this.correctAnswerPercentage = (correctNumber / numQuestion) * 100

              let feedBackType = _this.typeFeedbackExam
              if (feedBackType === 1) {
                _this.showPercentage = true
                _this.showCorrectAnswers = true
                this.canAnswer = true
              } else if (feedBackType === 2) {
                _this.showPercentage = true
                this.canAnswer = true
              } else if (_this.$route.query.currentExam === 'true') {
                _this.showResultDialog = true;
                _this.dialogResult = ' شما پاسخنامه خود را یکبار ثبت کرده اید، نتایج آزمون را بعد از اتمام ساعت پایان آزمون میتوانید در سوابق آزمون مشاهده کنید.'
                this.canAnswer = true
              }
              this.totalResult = totalResult;

              if (_this.examDetail.TypeHoldingExam === 1) {
                this.ranks.push({
                  type: "رتبه در کل مدرسه",
                  value: json[0].RankingSchool
                });
                this.ranks.push({
                  type: "رتبه در پایه",
                  value: json[0].RankingGrade
                });
                this.ranks.push({
                  type: "رتبه در کلاس",
                  value: json[0].RankingClass
                });
              } else if (_this.examDetail.TypeHoldingExam === 2) {
                this.ranks.push({
                  type: "رتبه در کل مدارس",
                  value: json[0].RankingAllSchool
                });
                this.ranks.push({
                  type: "رتبه در کل مدرسه",
                  value: json[0].RankingSchool
                });
                this.ranks.push({
                  type: "رتبه در پایه",
                  value: json[0].RankingGrade
                });
                this.ranks.push({
                  type: "رتبه در کلاس",
                  value: json[0].RankingClass
                });
              } else if (_this.examDetail.TypeHoldingExam === 3) {
                this.ranks.push({
                  type: "رتبه در کلاس",
                  value: json[0].RankingClass
                });
              } else if (_this.examDetail.TypeHoldingExam === 4) {
                this.ranks.push({
                  type: "رتبه در کلاس",
                  value: json[0].RankingClass
                });
              } else if (_this.examDetail.TypeHoldingExam === 5) {
                this.ranks.push({
                  type: "رتبه در پایه",
                  value: json[0].RankingGrade
                });
                this.ranks.push({
                  type: "رتبه در کلاس",
                  value: json[0].RankingClass
                });
              } else if (_this.examDetail.TypeHoldingExam === 6) {
                this.ranks.push({
                  type: "رتبه در پایه",
                  value: json[0].RankingGrade
                });
                this.ranks.push({
                  type: "رتبه در کلاس",
                  value: json[0].RankingClass
                });
              }


              _this.disabledRegisterBtn = true;
            } else {

              //if (this.canAnswer && this.currentExam) {
              if ((!this.canAnswer) || (!this.currentExam)) {
                _this.showResultDialog = true;
                _this.dialogResult = 'مهلت شما برای پاسخ به سوالات به اتمام رسیده در صورت ثبت نکردن پاسخ ها،میتوانید  تا پایان اتمام ساعت پایانی آزمون پاسخنامه خود را ثبت کنید.'
                _this.showAlert = false

              }
            }
          })
          .catch(error => console.log('error', error));
    },
    setAnswer() {
      this.showConfirmSetAnswer = false;
      this.showLoaderDialog = true
      let myHeaders = new Headers();
      myHeaders.append("Authorization", _this.$getUserData().token);
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      let urlencoded = new URLSearchParams();

      urlencoded.append("ExamDetialID", _this.examDetailID);

      let numQuestion = _this.examDetail.NumberQuestion
      let answers = this.fourChoiceAnswer
      let j = 0
      for (let i = 1; i <= numQuestion; i++) {
        urlencoded.append("YourAnswer[" + j + "].Key", i);
        if (answers[i] === undefined) {
          urlencoded.append("YourAnswer[" + j + "].Value", 0);
        } else {
          urlencoded.append("YourAnswer[" + j + "].Value", answers[i]);
        }
        j++;
      }


      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "ExamManagement/SetAnswer", requestOptions)
          .then(response => response.text())
          .then(result => {
            _this.showLoaderDialog = false

            _this.dialogResult = result;
            _this.showResultDialog = true
            _this.canAnswer = true
            _this.showAlert = false
            _this.getCorrectAnswers(_this.examDetailID)
          })
          .catch(error => console.log('error', error));
    },
    goBackPage() {
      this.$router.replace({path: "OnlineExam"})
    },
    async getLessons() {
      let myHeaders = new Headers();
      myHeaders.append("Authorization", _this.$getUserData().token);

      let requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };
      await fetch(this.$baseUrl + "ExamManagement/LessonsList", requestOptions)
          .then(response => response.text())
          .then(result => {
            this.lessonsList = JSON.parse(result);
            let questionLessonsArray = Object.values(questionLessons);
            this.uniqueLessons = [...new Set(questionLessonsArray)];
            this.lessonWithNames = this.lessonsList.filter(el => {
              return this.uniqueLessons.some(f => {
                return f === el.LessonsFunID;
              });
            });
          })
          .catch(error => console.log('error', error));
    },
  }
}
</script>

<style scoped>

</style>